﻿// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler';

// App imports.
import listViewApp from './vue/listView';

// Mounting containers listing and DOM targeting.
const listViewContainer = document.getElementById('list-view');

const listViewWidgetContainers = document.querySelectorAll('.widget-list-view');

// For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
document.addEventListener('DOMContentLoaded', () => {
    if (listViewContainer) {
        createApp(listViewApp).mount(listViewContainer);
    }

    if (listViewWidgetContainers.length) {
        listViewWidgetContainers.forEach(container => {
            createApp(listViewApp).mount(container);
        });
    }
});